import { AuthState } from '../auth/auth.types';
// import { AppState } from '../app/app.types';
import { AdminState } from '../admin/admin.types';
import { mmsStore } from '../app/app.config';

// TODO : Remove this later
export const pickToken = (authState: AuthState, adminState: AdminState | undefined): string =>
  adminState !== undefined && adminState.impersonation.authToken ?
    adminState.impersonation.authToken :
    authState.authToken;

export const pickAuthOrImpersonationToken = (): string => {
  const adminState: AdminState = (mmsStore.getState() as any).adminState;
  const authState: AuthState = (mmsStore.getState() as any).authState;

  return adminState !== undefined && adminState.impersonation.authToken ?
    adminState.impersonation.authToken :
    authState.authToken;
};


// WEBPACK FOOTER //
// ./src/util/token.util.tsx